"use strict"
;(() => {
    const forms = document.getElementsByClassName("raffle-participation-form")
    Array.from(forms).forEach((form) => {
        const consentCheckbox = form.querySelector(".consent-checkbox input")
        const consentLabel = form.querySelector(".consent-checkbox label")
        const consentMessage = form.querySelector(
            ".consent-checkbox .wm-form-message"
        )
        form.addEventListener(
            "submit",
            (event) => {
                if (!consentCheckbox.checked) {
                    event.preventDefault()
                    event.stopPropagation()
                    consentCheckbox.setAttribute("aria-invalid", "true")
                    consentLabel.classList.add("wm-form-label--error")
                    consentMessage.innerHTML = "Pflichtfeld"
                } else {
                    form.submit()
                }
            },
            false
        )
    })
})()
